import { Pipe, PipeTransform } from '@angular/core';
import { DocumentStatus } from '@workspaces/models/documents';

@Pipe({
  name: 'documentStatus',
  standalone: true,
  pure: true
})
export class DocumentStatusPipe implements PipeTransform {
  transform(value: DocumentStatus | null | undefined): string {
    if (!value) {
      return 'Unknown';
    }

    switch (value.toUpperCase()) {
      case 'FAILED':
        return 'Upload Failed';
      case 'WAITING_FOR_UPLOAD':
        return 'Awaiting Upload';
      case 'PROCESSING':
        return 'Processing Document...';
      case 'PROCESSED':
        return 'Completed';
      default:
        return this.capitalizeWords((value as string).replace(/_/g, ' '));
    }
  }

  private capitalizeWords(text: string): string {
    return text
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
